import { useMemo } from "react";
import { useAuthState } from "@/store/auth";
import { getUserTimezone } from "@/utils/user";

export const useUserTimezone = () => {
  const profile = useAuthState((state) => state.profile);

  const userTimezone = useMemo(() => {
    return getUserTimezone(profile);
  }, [profile]);

  return userTimezone;
};
